import {isNil, isNotNil} from 'ramda';

import type {AppSyncErrorPayload} from '../types';

/**
 * Type guard for an AppSync application-level error message payload, e.g.
 * `{errors: [{errorType, message, errorCode}]}`.
 */
export const isAppSyncErrorPayload = (value: unknown): value is AppSyncErrorPayload => {
  if (typeof value !== 'object' || isNil(value) || !('errors' in value)) {
    return false;
  }

  const {errors} = value;

  return (
    Array.isArray(errors) &&
    errors.length > 0 &&
    errors.every(
      (entry) =>
        typeof entry === 'object' &&
        isNotNil(entry) &&
        'message' in entry &&
        typeof entry.message === 'string'
    )
  );
};
